/**
 * gallery.js
 * 全商品ページ共通 画像ギャラリーモジュール
 *
 * 使い方:
 *   initGallery('bathbomb')
 *   initGallery('vape', { jumpParam: 'grape', jumpMap: { grape: 3 } })
 *
 * 対応HTML要素（prefix='bathbomb' の場合）:
 *   メインスライド:  #bathbombGalleryMain 内 .bathbomb-gallery-slide
 *   サムネイル:      #bathbombGalleryThumbs 内 .bathbomb-thumb-btn
 *   前へボタン:      #bathbombGalleryPrev
 *   次へボタン:      #bathbombGalleryNext
 *   アクティブ:      .is-active
 *
 * options:
 *   jumpParam {string|null} - URLパラメータの値（フレーバー名・香り名など）
 *   jumpMap  {Object|null} - パラメータ値→スライドインデックスのマッピング
 */

/* eslint-disable no-var */
function initGallery(prefix, options) {
  'use strict';

  options = options || {};

  /* --- 要素取得 --- */
  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  var mainId  = prefix + 'GalleryMain';
  var thumbId = prefix + 'GalleryThumbs';
  var prevId  = prefix + 'GalleryPrev';
  var nextId  = prefix + 'GalleryNext';

  var mainEl  = document.getElementById(mainId);
  var slides  = mainEl ? mainEl.querySelectorAll('.' + prefix + '-gallery-slide') : [];
  var thumbs  = document.getElementById(thumbId)
    ? document.getElementById(thumbId).querySelectorAll('.' + prefix + '-thumb-btn')
    : [];
  var btnPrev = document.getElementById(prevId);
  var btnNext = document.getElementById(nextId);

  if (!slides.length) return null;

  /* --- スライド切り替え --- */
  var current = 0;

  function goTo(i) {
    if (i < 0) i = slides.length - 1;
    if (i >= slides.length) i = 0;
    slides[current].classList.remove('is-active');
    if (thumbs[current]) thumbs[current].classList.remove('is-active');
    current = i;
    slides[current].classList.add('is-active');
    if (thumbs[current]) thumbs[current].classList.add('is-active');
  }

  /* --- サムネイルクリック --- */
  for (var t = 0; t < thumbs.length; t++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        goTo(parseInt(btn.dataset.index, 10));
      });
    })(thumbs[t]);
  }

  /* --- 前後ボタン --- */
  if (btnPrev) {
    btnPrev.addEventListener('click', function () {
      goTo(current - 1);
    });
  }
  if (btnNext) {
    btnNext.addEventListener('click', function () {
      goTo(current + 1);
    });
  }

  /* --- スワイプ操作 --- */
  if (mainEl) {
    var touchStartX = 0;
    mainEl.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        goTo(dx < 0 ? current + 1 : current - 1);
      }
    }, { passive: true });
  }

  /* --- 画像1枚の場合はボタン非表示 --- */
  if (slides.length <= 1) {
    if (btnPrev) btnPrev.style.display = 'none';
    if (btnNext) btnNext.style.display = 'none';
  }

  /* --- URLパラメータによるスライドジャンプ --- */
  var jumpParam = options.jumpParam || null;
  var jumpMap   = options.jumpMap   || null;
  if (jumpParam && jumpMap) {
    var jumpIndex = jumpMap[jumpParam];
    if (typeof jumpIndex === 'number') {
      goTo(jumpIndex);
    }
  }

  return goTo;
}
